import React from 'react'

import getFluidGatsbyImage from '../../../utils/gatsby-storyblok-image-fixed/getFluidGatsbyImage'
import RailsSection from '../../rails-section'
import { getPath } from '../../../utils/paths'
import InfoImageCard, { InfoImageCardProps } from '../../info-image-card'

interface CaseStudy {
  full_slug: string;
  content?: {
    title: string;
    subtitle: string;
    gridImage: Record<string, any>;
    about?: {
      projectStats?: {
        _uid: string;
        name: string;
        value: string;
      }[];
    }[];
  };
}

interface StoryblokFeaturedCaseStudiesProps {
  title: string;
  text: string;
  caseStudies?: {
    _uid: string;
    caseStudy?: CaseStudy;
  }[];
}

function StoryblokFeaturedCaseStudies(
  props: StoryblokFeaturedCaseStudiesProps
) {
  const { caseStudies, title, text } = props
  const filteredCaseStudies = parseCaseStudies(caseStudies)

  if (!filteredCaseStudies || filteredCaseStudies.length === 0) return null

  return (
    <RailsSection
      title={title}
      text={text}
      cta={{ to: getPath.caseStudies(), title: 'View all case studies' }}
      large={false}
      dark
    >
      {filteredCaseStudies.map((caseStudy) => (
        <InfoImageCard {...caseStudy} key={caseStudy.id} />
      ))}
    </RailsSection>
  )
}

const parseCaseStudies = (
  caseStudies: StoryblokFeaturedCaseStudiesProps['caseStudies']
) => {
  return caseStudies
    ?.map(
      (caseStudy) =>
        caseStudy.caseStudy?.content &&
        ({
          id: caseStudy._uid,
          title: caseStudy.caseStudy.content.title,
          text: caseStudy.caseStudy.content.subtitle,
          image: getFluidGatsbyImage(caseStudy.caseStudy.content.gridImage, {
            maxWidth: 800,
            maxHeight: 500
          }),
          link: {
            to: `/${caseStudy.caseStudy.full_slug}`,
            title: 'View Case Study'
          },
          keyPoints: getKeyStats(caseStudy.caseStudy.content.about)
        } satisfies InfoImageCardProps & { id: string })
    )
    .filter((item): item is NonNullable<typeof item> => !!item)
}

const getKeyStats = (
  data: NonNullable<CaseStudy['content']>['about']
): InfoImageCardProps['keyPoints'] => {
  return data?.[0]?.projectStats
    ?.map((stats) => ({
      title: stats.name,
      text: stats.value
    }))
    .slice(0, 4)
}

export default StoryblokFeaturedCaseStudies
